export type CaseBandGeometry = {
    innerRadius: number;
    outerRadius: number;
    whenBoundary: 'inner' | 'outer';
};

export function deriveCaseBandGeometry(args: {
    whenRingRadius: number | undefined;
    whatRingRadius: number | undefined;
    whenTubeRadius: number;
    whatTubeRadius: number;
    gutter: number;
    minWidth: number;
}): CaseBandGeometry | null {
    const {
        whenRingRadius,
        whatRingRadius,
        whenTubeRadius,
        whatTubeRadius,
        gutter,
        minWidth,
    } = args;

    if (whenRingRadius == null || whatRingRadius == null) return null;

    let innerBoundaryRadius: number;
    let outerBoundaryRadius: number;
    let whenBoundary: 'inner' | 'outer';

    if (whenRingRadius <= whatRingRadius) {
        innerBoundaryRadius = whenRingRadius + whenTubeRadius;
        outerBoundaryRadius = whatRingRadius - whatTubeRadius;
        whenBoundary = 'inner';
    } else {
        innerBoundaryRadius = whatRingRadius + whatTubeRadius;
        outerBoundaryRadius = whenRingRadius - whenTubeRadius;
        whenBoundary = 'outer';
    }

    const innerRadius = innerBoundaryRadius + gutter;
    const outerRadius = outerBoundaryRadius - gutter;

    if (!Number.isFinite(innerRadius) || !Number.isFinite(outerRadius)) return null;
    if (outerRadius - innerRadius < minWidth) return null;

    return {
        innerRadius,
        outerRadius,
        whenBoundary,
    };
}
